<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 sm9>
        <v-select :items="children" label="Select child" v-model="selectedChildren" required autocomplete clearable chips @input="updateChildren()" item-text="firstName" open-on-clear>
          <template slot="selection" slot-scope="data">
            <v-chip :selected="data.selected" :key="data.item.id" class="chip--select-multi" @input="data.parent.selectItem(data.item)">
              <v-avatar color="grey">
                {{ data.item.firstName.charAt(0) }}
              </v-avatar>
              {{ data.item.firstName + ' ' + data.item.lastName }}
            </v-chip>
          </template>
          <template slot="item" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title v-html="data.item.firstName + ' ' + data.item.lastName"></v-list-tile-title>
            </v-list-tile-content>
          </template>
        </v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selectedChildren: null
    };
  },
  props: ["children"],
  methods: {
    /** Sends selectedChildren back to parent component. */
    updateChildren() {
      console.log(this.selectedChildren);
      this.$emit("input", this.selectedChildren);
    }
  }
};
</script>